let doorPricesCache = null;
let doorPricesPromise = null;

function getDoorStyle() {
  const match = window.location.pathname.match(/style-(\d+)\/?$/i);
  return match ? parseInt(match[1], 10) : null;
}

async function loadDoorPrices() {
  if (doorPricesCache) return doorPricesCache;
  if (doorPricesPromise) return doorPricesPromise;

  const script = document.querySelector('script[src*="ff-configurator"]');
  const url =
    script && script.src
      ? script.src.replace(/ff-configurator\.js[^/]*$/, 'ff-door-prices.json')
      : '/assets/ff-door-prices.json';

  doorPricesPromise = fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error('FF door prices HTTP ' + response.status);
      return response.json();
    })
    .then((data) => {
      doorPricesCache = data;
      return doorPricesCache;
    })
    .catch((err) => {
      doorPricesPromise = null;
      console.error('FF configurator: failed to load door prices', err);
      throw err;
    });

  return doorPricesPromise;
}

(() => {
  const root = document.querySelector('[data-ff-configurator]');
  if (!root) return;

  const jsonEl = root.querySelector('[data-ff-config-json]');
  if (!jsonEl) return;

  let config;
  try {
    config = JSON.parse(jsonEl.textContent);
  } catch (e) {
    console.error('FF configurator: invalid config JSON', e);
    return;
  }

  const widthInput = root.querySelector('[data-ff-width]');
  const heightInput = root.querySelector('[data-ff-height]');
  const quantityInput = root.querySelector('[data-ff-quantity]');
  const bulkOrderInput = root.querySelector('[data-ff-bulk-order]');
  const bulkDetailsEl = root.querySelector('[data-ff-bulk-details]');
  const bulkRequirementInput = root.querySelector('[data-ff-bulk-requirement]');
  const unitButtons = [...root.querySelectorAll('[data-ff-unit]')];
  const widthUnit = root.querySelector('[data-ff-width-unit]');
  const heightUnit = root.querySelector('[data-ff-height-unit]');
  const widthHint = root.querySelector('[data-ff-width-hint]');
  const heightHint = root.querySelector('[data-ff-height-hint]');
  const totalEls = root.querySelectorAll('[data-ff-total], [data-ff-total-mobile]');
  const discountEl = root.querySelector('[data-ff-discount]');
  const summaryEl = root.querySelector('[data-ff-summary]');
  const statusEl = root.querySelector('[data-ff-status]');
  const modal = root.querySelector('[data-ff-modal]');
  const quoteConfigInput = root.querySelector('[data-ff-quote-config]');
  const quoteBodyInput = root.querySelector('[data-ff-quote-body]');
  const quoteMessage = root.querySelector('[data-ff-quote-message]');
  const quoteForm = root.querySelector('.ff-configurator__quote-form');
  const ralInputWrapper = root.querySelector('#ff-ral-input-wrapper');
  const ralCodeInput = root.querySelector('#ff-ral-code');
  const threshWidthEl = document.getElementById('ff-threshold-width');
  const threshHeightEl = document.getElementById('ff-threshold-height');
  const THRESHOLD_VALUE = 'Double Ramp';
  let currentUnit = 'mm';

  function updateThresholdSizes() {
    if (!threshWidthEl && !threshHeightEl) return;
    const hasWidth = widthInput?.value.trim() !== '';
    const hasHeight = heightInput?.value.trim() !== '';
    const unitLabel = currentUnit === 'inches' ? 'inches' : 'mm';

    if (threshWidthEl) {
      threshWidthEl.textContent = hasWidth
        ? `${currentUnit === 'inches' ? formatInches(Number(widthInput.value)) : Math.round(Number(widthInput.value))} ${unitLabel}`
        : '—';
    }
    if (threshHeightEl) {
      threshHeightEl.textContent = hasHeight
        ? `${currentUnit === 'inches' ? formatInches(Number(heightInput.value)) : Math.round(Number(heightInput.value))} ${unitLabel}`
        : '—';
    }
  }

  function isCustomRalColour(label) {
    if (!label) return false;
    return label.trim().toLowerCase() === 'custom ral';
  }

  function isValidRalCode(value) {
    const digits = value.replace(/^ral\s*/i, '').trim();
    return /^\d{4}$/.test(digits);
  }

  function applySizeUnitUI() {
    if (!widthInput || !heightInput) return;
    const isInches = currentUnit === 'inches';

    widthInput.min = isInches ? formatInches(mmToInches(config.minWidth)) : config.minWidth;
    widthInput.max = isInches ? formatInches(mmToInches(config.maxWidth)) : config.maxWidth;
    heightInput.min = isInches ? formatInches(mmToInches(config.minHeight)) : config.minHeight;
    heightInput.max = isInches ? formatInches(mmToInches(config.maxHeight)) : config.maxHeight;
    widthInput.step = isInches ? '0.01' : '1';
    heightInput.step = isInches ? '0.01' : '1';

    widthInput.placeholder = isInches
      ? `${formatInches(mmToInches(config.minWidth))}–${formatInches(mmToInches(config.maxWidth))}`
      : `${config.minWidth}–${config.maxWidth}`;
    heightInput.placeholder = isInches
      ? `${formatInches(mmToInches(config.minHeight))}–${formatInches(mmToInches(config.maxHeight))}`
      : `${config.minHeight}–${config.maxHeight}`;

    if (widthUnit) widthUnit.textContent = isInches ? 'inches' : 'mm';
    if (heightUnit) heightUnit.textContent = isInches ? 'inches' : 'mm';
    if (widthHint) {
      widthHint.textContent = isInches
        ? `${formatInches(mmToInches(config.minWidth))}–${formatInches(mmToInches(config.maxWidth))} inches`
        : `${config.minWidth}–${config.maxWidth} mm`;
    }
    if (heightHint) {
      heightHint.textContent = isInches
        ? `${formatInches(mmToInches(config.minHeight))}–${formatInches(mmToInches(config.maxHeight))} inches`
        : `${config.minHeight}–${config.maxHeight} mm`;
    }
  }

  function updateRalInputVisibility(colourLabel) {
    if (!ralInputWrapper || !ralCodeInput) return;
    if (isCustomRalColour(colourLabel)) {
      ralInputWrapper.style.display = 'block';
      ralCodeInput.setAttribute('required', 'required');
    } else {
      ralInputWrapper.style.display = 'none';
      ralCodeInput.removeAttribute('required');
      ralCodeInput.value = '';
    }
  }

  const money = (n) => `£${Number(n).toFixed(2)}`;
  const mmToInches = (mm) => Number(mm) / 25.4;
  const inchesToMm = (inches) => Number(inches) * 25.4;
  const formatInches = (value) => Number(value.toFixed(2));

  const selectedRadio = (selector) => root.querySelector(`${selector}:checked`);
  const selectedExtras = () => [...root.querySelectorAll('[data-ff-extra]:checked')];

  function syncSelectedClass(groupSelector, itemSelector) {
    root.querySelectorAll(groupSelector).forEach((group) => {
      group.querySelectorAll(itemSelector).forEach((item) => {
        const input = item.querySelector('input');
        item.classList.toggle('is-selected', !!(input && input.checked));
      });
    });
  }

  const stepEls = [...root.querySelectorAll('[data-ff-step]')].sort(
    (a, b) => Number(a.dataset.stepIndex) - Number(b.dataset.stepIndex)
  );

  function updateStepStatus(stepEl) {
    const status = stepEl.querySelector('[data-ff-step-status]');
    if (!status) return;
    if (stepEl.classList.contains('is-locked')) {
      status.textContent = '🔒';
      status.style.color = '';
      status.hidden = false;
      status.setAttribute('aria-hidden', 'false');
    } else if (stepEl.classList.contains('is-complete')) {
      status.textContent = '✓';
      status.style.color = '#4CAF50';
      status.hidden = false;
      status.setAttribute('aria-hidden', 'false');
    } else {
      status.textContent = '';
      status.hidden = true;
      status.setAttribute('aria-hidden', 'true');
    }
  }

  function clearStepSelections(stepEl) {
    stepEl.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
    });
    if (stepEl.dataset.ffStep === 'extras') {
      stepEl.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.checked = false;
      });
      delete stepEl.dataset.extrasTouched;
    }
    if (stepEl.dataset.ffStep === 'colour') {
      updateRalInputVisibility('');
    }
  }

  function lockStep(stepEl) {
    stepEl.classList.add('is-locked');
    stepEl.classList.remove('is-complete', 'unlocking');
    updateStepStatus(stepEl);
  }

  function unlockStep(stepIndex) {
    const stepEl = stepEls[stepIndex];
    if (!stepEl || !stepEl.classList.contains('is-locked')) return;
    stepEl.classList.remove('is-locked');
    stepEl.classList.add('unlocking');
    updateStepStatus(stepEl);
    window.setTimeout(() => stepEl.classList.remove('unlocking'), 400);
  }

  function resetFromStep(stepIndex) {
    for (let i = stepIndex + 1; i < stepEls.length; i++) {
      clearStepSelections(stepEls[i]);
      lockStep(stepEls[i]);
    }
  }

  function isSizeValid() {
    if (!widthInput || !heightInput) return false;
    if (widthInput.value.trim() === '' || heightInput.value.trim() === '') return false;
    const w = inputValueToMm(widthInput.value);
    const h = inputValueToMm(heightInput.value);
    return (
      !Number.isNaN(w) &&
      !Number.isNaN(h) &&
      w >= config.minWidth &&
      w <= config.maxWidth &&
      h >= config.minHeight &&
      h <= config.maxHeight
    );
  }

  function completeStep(stepIndex) {
    const stepEl = stepEls[stepIndex];
    if (!stepEl) return;
    stepEl.classList.add('is-complete');
    updateStepStatus(stepEl);
    if (stepIndex < stepEls.length - 1) {
      unlockStep(stepIndex + 1);
    }
  }

  function onSizeChange() {
    const sizeIndex = stepEls.findIndex((el) => el.dataset.ffStep === 'size');
    if (sizeIndex < 0) return;
    const sizeEl = stepEls[sizeIndex];

    if (!isSizeValid()) {
      if (sizeEl.classList.contains('is-complete')) {
        sizeEl.classList.remove('is-complete');
        updateStepStatus(sizeEl);
        resetFromStep(sizeIndex);
      }
      return;
    }

    const wasComplete = sizeEl.classList.contains('is-complete');
    if (wasComplete) resetFromStep(sizeIndex);
    completeStep(sizeIndex);
  }

  function onStepSelectionChange(input) {
    const stepEl = input.closest('[data-ff-step]');
    if (!stepEl) return;
    const stepIndex = stepEls.indexOf(stepEl);
    if (stepIndex < 0) return;

    if (stepEl.dataset.ffStep === 'extras') {
      stepEl.dataset.extrasTouched = 'true';
      const wasComplete = stepEl.classList.contains('is-complete');
      if (wasComplete) resetFromStep(stepIndex);
      completeStep(stepIndex);
      return;
    }

    if (stepEl.dataset.ffStep === 'colour' && input.matches('[data-ff-colour]')) {
      updateRalInputVisibility(input.checked ? input.value : '');
    }

    if (input.type === 'radio' && !input.checked) return;

    const wasComplete = stepEl.classList.contains('is-complete');
    if (wasComplete) resetFromStep(stepIndex);
    completeStep(stepIndex);
  }

  function initOptionSliders() {
    root.querySelectorAll('[data-ff-option-slider]').forEach((slider) => {
      const wrapper = slider.querySelector('.ff-option-track-wrapper');
      const prev = slider.querySelector('.ff-slider-arrow--prev');
      const next = slider.querySelector('.ff-slider-arrow--next');
      if (!wrapper || !prev || !next) return;

      const scrollAmount = 120;

      function updateArrows() {
        const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
        prev.disabled = wrapper.scrollLeft <= 0;
        next.disabled = maxScroll <= 0 || wrapper.scrollLeft >= maxScroll - 1;
      }

      prev.addEventListener('click', () => {
        wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      wrapper.addEventListener('scroll', updateArrows, { passive: true });

      let touchStartX = 0;
      wrapper.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );
      wrapper.addEventListener(
        'touchend',
        (e) => {
          const diff = touchStartX - e.changedTouches[0].screenX;
          if (Math.abs(diff) < 50) return;
          wrapper.scrollBy({ left: diff > 0 ? scrollAmount : -scrollAmount, behavior: 'smooth' });
        },
        { passive: true }
      );

      updateArrows();
      window.addEventListener('resize', updateArrows);
    });
  }

  function clamp(value, min, max) {
    const n = Number(value);
    if (Number.isNaN(n)) return min;
    return Math.min(max, Math.max(min, n));
  }

  function inputValueToMm(value) {
    return currentUnit === 'inches' ? inchesToMm(value) : Number(value);
  }

  function discountRateFor(quantity) {
    if (quantity >= 10) return 0.1;
    if (quantity >= 5) return 0.075;
    if (quantity >= 2) return 0.05;
    return 0;
  }

  function formatDiscountPercent(rate) {
    const pct = rate * 100;
    return Number.isInteger(pct) ? String(pct) : pct.toFixed(1).replace(/\.0$/, '');
  }

  async function getState() {
    const width = clamp(inputValueToMm(widthInput.value), config.minWidth, config.maxWidth);
    const height = clamp(inputValueToMm(heightInput.value), config.minHeight, config.maxHeight);
    const quantity = Math.round(clamp(quantityInput?.value || 1, 1, 999));
    if (quantityInput) quantityInput.value = quantity;
    const isBulkOrder = !!(bulkOrderInput && bulkOrderInput.checked);
    const bulkRequirement = isBulkOrder ? (bulkRequirementInput?.value || '').trim() : '';
    if (bulkDetailsEl) bulkDetailsEl.hidden = !isBulkOrder;

    const colour = selectedRadio('[data-ff-colour]');
    const glass = selectedRadio('[data-ff-glass]');
    const handle = selectedRadio('[data-ff-handle]');
    const opening = selectedRadio('[data-ff-opening]');
    const hinge = selectedRadio('[data-ff-hinge]');
    const closer = selectedRadio('[data-ff-closer]');
    const extras = selectedExtras();

    let unitPrice = Number(config.basePrice) || 0;

    const style = getDoorStyle();
    const prices = await loadDoorPrices();
    const cfg = style != null ? prices[String(style)] : null;
    if (cfg) {
      let sizePrice = cfg.a + 0.4 * (width + height) - 5;
      sizePrice = Math.max(1, Math.round(sizePrice * 100) / 100);
      unitPrice = sizePrice;
    }

    const colourUplift = Number(colour?.dataset.uplift || 0);
    const glassUplift = Number(glass?.dataset.uplift || 0);
    const handleUplift = Number(handle?.dataset.uplift || 0);
    const extrasTotal = extras.reduce((sum, el) => sum + Number(el.dataset.price || 0), 0);

    unitPrice += colourUplift + glassUplift + handleUplift + extrasTotal;

    const subtotal = unitPrice * quantity;
    const discountRate = discountRateFor(quantity);
    const discountAmount = subtotal * discountRate;
    const total = subtotal - discountAmount;
    const displayWidth = currentUnit === 'inches' ? `${formatInches(mmToInches(width))} in` : `${Math.round(width)} mm`;
    const displayHeight = currentUnit === 'inches' ? `${formatInches(mmToInches(height))} in` : `${Math.round(height)} mm`;

    return {
      width: Math.round(width * 100) / 100,
      height: Math.round(height * 100) / 100,
      displayWidth,
      displayHeight,
      quantity,
      isBulkOrder,
      bulkRequirement,
      colour: colour?.value || '',
      ralCode: ralCodeInput?.value?.trim() || '',
      glass: glass?.value || '',
      handle: handle?.value || '',
      opening: opening?.value || '',
      hinge: hinge?.value || '',
      closer: closer?.value || '',
      threshold: THRESHOLD_VALUE,
      extras: extras.map((el) => el.value),
      extrasLabel: extras.map((el) => el.value).join(', '),
      unitPrice: Math.round(unitPrice * 100) / 100,
      discountRate,
      discountAmount: Math.round(discountAmount * 100) / 100,
      total: Math.round(total * 100) / 100,
    };
  }

  async function render() {
    syncSelectedClass('.ff-option-track', '.ff-option-card');

    const state = await getState();
    totalEls.forEach((el) => {
      el.textContent = money(state.total);
    });
    if (discountEl) {
      discountEl.hidden = state.discountAmount <= 0;
      discountEl.textContent =
        state.discountAmount > 0
          ? `Bulk discount (${formatDiscountPercent(state.discountRate)}%): −${money(state.discountAmount)}`
          : '';
    }

    if (summaryEl) {
      const sizeLabel = isSizeValid() ? `${state.displayWidth} × ${state.displayHeight}` : '';
      const rows = [
        ['Size', sizeLabel],
        ['Quantity', state.quantity],
        ['Bulk Order', state.isBulkOrder ? 'Yes' : 'No'],
        ['Bulk Requirement', state.bulkRequirement],
        ['Colour', state.colour],
        ['RAL Code', state.ralCode],
        ['Glass', state.glass],
        ['Handle', state.handle],
        ['Opening', state.opening],
        ['Hinged', state.hinge],
        ['Closer', state.closer],
        ['Extras', state.extrasLabel],
        ['Threshold', state.threshold],
      ];
      summaryEl.innerHTML = rows
        .filter(([, v]) => v)
        .map(([k, v]) => `<li><span>${k}</span><strong>${v}</strong></li>`)
        .join('');
    }

    const configText = [
      `Product: ${config.productTitle}`,
      `Width: ${state.width} mm`,
      `Height: ${state.height} mm`,
      `Quantity: ${state.quantity}`,
      `Bulk Order: ${state.isBulkOrder ? 'Yes' : 'No'}`,
      state.bulkRequirement ? `Bulk Requirement: ${state.bulkRequirement}` : null,
      `Colour: ${state.colour}`,
      state.ralCode ? `RAL Code: ${state.ralCode}` : null,
      `Glass: ${state.glass}`,
      `Handle: ${state.handle}`,
      `Opening: ${state.opening}`,
      `Hinged: ${state.hinge}`,
      `Closer: ${state.closer}`,
      `Extras: ${state.extrasLabel}`,
      `Threshold: ${state.threshold}`,
      `Unit price: ${money(state.unitPrice)}`,
      `Bulk discount: ${formatDiscountPercent(state.discountRate)}% (${money(state.discountAmount)})`,
      `Estimated total: ${money(state.total)}`,
    ]
      .filter(Boolean)
      .join('\n');

    if (quoteConfigInput) quoteConfigInput.value = configText;
    if (quoteBodyInput) {
      const message = quoteMessage?.value?.trim();
      quoteBodyInput.value = message
        ? `${message}\n\n--- Configuration ---\n${configText}`
        : configText;
    }

    updateThresholdSizes();
    return state;
  }

  function setStatus(message, isError) {
    if (!statusEl) return;
    statusEl.hidden = !message;
    statusEl.textContent = message || '';
    statusEl.classList.toggle('is-error', !!isError);
  }

  async function addToCart() {
    const state = await render();
    if (!config.variantId) {
      setStatus('This product is unavailable.', true);
      return;
    }

    if (isCustomRalColour(state.colour)) {
      if (!state.ralCode) {
        setStatus('Please enter your RAL code.', true);
        ralCodeInput?.focus();
        return;
      }
      if (!isValidRalCode(state.ralCode)) {
        setStatus('Please enter a valid 4 digit RAL code.', true);
        ralCodeInput?.focus();
        return;
      }
    }

    setStatus('Adding to cart…', false);

    const formData = new FormData();
    formData.append('id', String(config.variantId));
    formData.append('quantity', String(state.quantity));
    formData.append('properties[Width]', `${state.width} mm`);
    formData.append('properties[Height]', `${state.height} mm`);
    formData.append('properties[Colour]', state.colour);
    if (state.ralCode) {
      formData.append('properties[RAL Code]', state.ralCode);
    }
    formData.append('properties[Glass]', state.glass);
    formData.append('properties[Handle]', state.handle);
    formData.append('properties[Opening]', state.opening);
    formData.append('properties[Hinged]', state.hinge);
    formData.append('properties[Closer]', state.closer);
    formData.append('properties[Extras]', state.extrasLabel);
    formData.append('properties[Threshold]', state.threshold);
    formData.append('properties[_unit_price]', money(state.unitPrice));
    formData.append('properties[_bulk_discount]', `${formatDiscountPercent(state.discountRate)}%`);
    formData.append('properties[_total_price]', money(state.total));
    formData.append('properties[Bulk Order]', state.isBulkOrder ? 'Yes' : 'No');
    if (state.bulkRequirement) {
      formData.append('properties[Bulk Requirement]', state.bulkRequirement);
    }

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await fetch(config.cartAddUrl || `${window.routes?.cart_add_url || '/cart/add'}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        setStatus(data.description || data.message || 'Could not add to cart.', true);
        return;
      }

      setStatus('Added to cart.', false);

      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
      } else if (window.location) {
        window.location.href = config.cartUrl || '/cart';
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error(err);
      setStatus('Could not add to cart. Please try again.', true);
    }
  }

  async function openModal() {
    await render();
    if (!modal) return;

    if (!modal.dataset.ffPortaled) {
      const placeholder = document.createComment('ff-quote-modal');
      modal.parentNode.insertBefore(placeholder, modal);
      modal._ffPlaceholder = placeholder;
      document.body.appendChild(modal);
      modal.dataset.ffPortaled = 'true';
    }

    modal.hidden = false;
    modal.classList.add('is-open');
    document.documentElement.classList.add('ff-configurator-modal-open');
    document.body.classList.add('ff-configurator-modal-open');
    const focusable = modal.querySelector('input, textarea, button');
    focusable?.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ff-configurator-modal-open');
    document.body.classList.remove('ff-configurator-modal-open');
  }

  root.addEventListener('input', (e) => {
    if (e.target.matches('[data-ff-width], [data-ff-height]')) {
      onSizeChange();
    }
    if (e.target.matches('input, textarea')) void render();
  });
  root.addEventListener('change', (e) => {
    if (e.target.matches('input')) {
      onStepSelectionChange(e.target);
      void render();
    }
  });

  unitButtons.forEach((button) => {
    button.addEventListener('click', async () => {
      const nextUnit = button.dataset.ffUnit;
      if (nextUnit === currentUnit) return;

      const hasWidth = widthInput.value.trim() !== '';
      const hasHeight = heightInput.value.trim() !== '';
      const state = await getState();
      currentUnit = nextUnit;
      const isInches = currentUnit === 'inches';

      if (hasWidth) {
        widthInput.value = isInches ? formatInches(mmToInches(state.width)) : Math.round(state.width);
      }
      if (hasHeight) {
        heightInput.value = isInches ? formatInches(mmToInches(state.height)) : Math.round(state.height);
      }
      applySizeUnitUI();

      unitButtons.forEach((unitButton) => {
        const isSelected = unitButton === button;
        unitButton.classList.toggle('is-selected', isSelected);
        unitButton.setAttribute('aria-pressed', String(isSelected));
      });
      void render();
    });
  });

  root.querySelectorAll('[data-ff-atc], [data-ff-atc-mobile]').forEach((btn) => {
    btn.addEventListener('click', addToCart);
  });
  root.querySelectorAll('[data-ff-quote-open]').forEach((btn) => {
    btn.addEventListener('click', openModal);
  });
  root.querySelectorAll('[data-ff-modal-close]').forEach((btn) => {
    btn.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  if (quoteForm) {
    quoteForm.addEventListener('submit', async (e) => {
      const state = await render();
      if (isCustomRalColour(state.colour)) {
        if (!state.ralCode) {
          e.preventDefault();
          setStatus('Please enter your RAL code.', true);
          ralCodeInput?.focus();
          return;
        }
        if (!isValidRalCode(state.ralCode)) {
          e.preventDefault();
          setStatus('Please enter a valid 4 digit RAL code.', true);
          ralCodeInput?.focus();
          return;
        }
      }
      await render();
    });
  }

  // Re-open modal after successful contact post
  if (root.querySelector('[data-ff-quote-success]') || /contact_posted=true/i.test(window.location.search)) {
    openModal();
  }

  stepEls.forEach((stepEl) => {
    stepEl.classList.remove('is-locked');
    updateStepStatus(stepEl);
  });
  async function applyDoorStyleRanges() {
    const style = getDoorStyle();
    if (style == null) return;
    try {
      const prices = await loadDoorPrices();
      const cfg = prices[String(style)];
      if (!cfg) return;
      config.minWidth = cfg.minW;
      config.maxWidth = cfg.maxW;
      config.minHeight = cfg.minH;
      config.maxHeight = cfg.maxH;
      if (widthInput) {
        widthInput.min = cfg.minW;
        widthInput.max = cfg.maxW;
      }
      if (heightInput) {
        heightInput.min = cfg.minH;
        heightInput.max = cfg.maxH;
      }
    } catch (err) {
      /* loadDoorPrices already logged */
    }
  }

  applyDoorStyleRanges().then(() => {
    applySizeUnitUI();
    updateThresholdSizes();
    initOptionSliders();
    void render();
  });
})();

// Threshold info modal
(function () {
  const modal = document.getElementById('ff-threshold-modal');
  if (!modal) return;

  function openThresholdModal() {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeThresholdModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ff-threshold-info]')) openThresholdModal();
    if (
      e.target.closest('[data-ff-threshold-close]') ||
      e.target === modal.querySelector('.ff-threshold-modal__backdrop')
    ) {
      closeThresholdModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeThresholdModal();
  });
})();

// Technical Data Sheet Modal
(function() {
  const modal = document.getElementById('ff-tds-modal');
  if (!modal) return;

  function openModal() {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-ff-tds-open]')) {
      e.preventDefault();
      openModal();
    }
    if (e.target.closest('[data-ff-tds-close]') || e.target === modal.querySelector('.ff-tds-modal__backdrop')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });
})();
